import { render, staticRenderFns } from "./FormRegistration.vue?vue&type=template&id=6581559a&scoped=true&"
import script from "./FormRegistration.vue?vue&type=script&lang=js&"
export * from "./FormRegistration.vue?vue&type=script&lang=js&"
import style0 from "./FormRegistration.vue?vue&type=style&index=0&id=6581559a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6581559a",
  null
  
)

export default component.exports